<template>
  <v-row>
    <v-col cols="12" align-self="center">
      <v-tabs v-model="tab" grow show-arrows height="35">
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-for="title in tabTitle" :key="title">
          {{ $t(title) }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item v-for="(title, index) in tabTitle" :key="title">
          <v-row class="mx-3 mt-2">
            <v-col>
              <v-text-field
                :label="$t('home.slogan_title')"
                @change="updateTitle($event, type[index])"
                :value="temp_title[type[index]]"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                :label="$t('home.slogan_subtitle')"
                @change="updateSubTitle($event, type[index])"
                :value="temp_subtitle[type[index]]"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row class="ma-3">
            <v-col>
              <v-text-field
                :label="$t('home.slogan_subtitle')"
                @change="updateSubTitle($event, type[index])"
                :value="temp_subtitle[type[index]]"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row class="ml-3">
            <v-col>
              {{ $t('home.slogan_description') }}
            </v-col>
          </v-row>
          <v-row class="d-flex align-center ms-3 mb-3">
            <v-col>
              <QuillEditor v-if="index == 0" editorID="editor1" :html.sync="temp_description_zh"></QuillEditor>
              <QuillEditor v-else-if="index == 1" editorID="editor2" :html.sync="temp_description_en"></QuillEditor>
              <QuillEditor v-else-if="index == 2" editorID="editor3" :html.sync="temp_description_cn"></QuillEditor>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import QuillEditor from '@/components/QuillEditor'
import { globalFunc } from '@/global'

export default {
  name: 'HomeTab',
  components: { QuillEditor },
  mixins: [globalFunc],
  props: ['description', 'title', 'subtitle', 'image_id'],
  data: () => ({
    tab: null,
    type: ['zh', 'en', 'cn'],
    tabTitle: ['general.zh', 'general.en', 'general.cn'],
    temp_title: {
      zh: '',
      en: '',
      cn: '',
    },
    temp_subtitle: {
      zh: '',
      en: '',
      cn: '',
    },
    temp_description_zh: '',
    temp_description_en: '',
    temp_description_cn: '',
  }),
  created() {
    if (globalFunc.DataValid(this.title)) {
      this.temp_title.zh = this.title.zh
      this.temp_title.en = this.title.en
      this.temp_title.cn = this.title.cn
    }

    if (globalFunc.DataValid(this.subtitle)) {
      this.temp_subtitle.zh = this.subtitle.zh
      this.temp_subtitle.en = this.subtitle.en
      this.temp_subtitle.cn = this.subtitle.cn
    }

    if (globalFunc.DataValid(this.description)) {
      this.temp_description_zh = this.description.zh
      this.temp_description_en = this.description.en
      this.temp_description_cn = this.description.cn
    }
  },
  methods: {
    updateTitle(event, type) {
      this.$emit('getTitle', event, type, this.image_id)
    },
    updateSubTitle(event, type) {
      this.$emit('getSubTitle', event, type, this.image_id)
    },
  },
  watch: {
    temp_description_zh: function(newVal, oldVal) {
      this.$emit('getDescription', newVal, 'zh', this.image_id)
    },
    temp_description_en: function(newVal, oldVal) {
      this.$emit('getDescription', newVal, 'en', this.image_id)
    },
    temp_description_cn: function(newVal, oldVal) {
      this.$emit('getDescription', newVal, 'cn', this.image_id)
    },
    title: function(newVal, oldVal) {
      this.temp_title.zh = newVal.zh
      this.temp_title.en = newVal.en
      this.temp_title.cn = newVal.cn
    },
    subtitle: function(newVal, oldVal) {
      this.temp_subtitle.zh = newVal.zh
      this.temp_subtitle.en = newVal.en
      this.temp_subtitle.cn = newVal.cn
    },
    description: function(newVal, oldVal) {
      this.temp_description_zh = newVal.zh
      this.temp_description_en = newVal.en
      this.temp_description_cn = newVal.cn
    },
  },
}
</script>
